Vue.component('ack-warranty-policies', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-warranty-policies',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-warranty-policies mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'warranty-policies-page',
			policyGroups: [
				{
					title: '3D Printers',
					policies: [
						{
							title: 'SOL Plus Warranty',
							image:
								window.ackShopifyFileUrl("V4_SOL_Plus.png"),
							url: 'https://go.ackuretta.com/sol-plus/warranty',
						},
						{
							title: 'SOL SE Warranty',
							image:
								window.ackShopifyFileUrl("sol_se_product.png"),
							url: window.ackShopifyFileUrl('SOL_and_SOL_SE_Warranty_2026.pdf'),
						},
						{
							title: 'DENTIQ Warranty',
							image:
								window.ackShopifyFileUrl("V4_DENTIQ.png"),
							url: 'https://go.ackuretta.com/DENTIQ/warranty',
						},
					],
				},
				{
					title: 'Post-Processing',
					policies: [
						{
							title: 'CLEANI Warranty',
							image:
								window.ackShopifyFileUrl("V4_Dual_Tanks.png"),
							url: 'https://go.ackuretta.com/CLEANI/warranty',
						},
						{
							title: 'CURIE Plus Warranty',
							image:
								window.ackShopifyFileUrl("CURIE_Plus_01.png"),
							url: 'https://go.ackuretta.com/curie-plus/warranty',
						},
						{
							title: 'NFinity Warranty',
							image:
								window.ackShopifyFileUrl("NFinity_2.png"),
							url: 'https://go.ackuretta.com/nfinity/warranty',
						},
						{
							title: 'CURIE Warranty',
							image:
								window.ackShopifyFileUrl("CURIE_1_1.png"),
							url: 'https://go.ackuretta.com/CURIE/warranty',
						},
						{
							title: 'UV Box Warranty',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/products/UV-BOX.png?v=1703663929',
							url: 'https://go.ackuretta.com/uv-box/warranty',
						},
					],
				},
				{
					title: 'Ackuretta Concierge',
					policies: [
						{
							title: 'Concierge Services Policy',
							image:
								window.ackShopifyFileUrl("Concierge_Service_logo_Color-2.png"),
							url: 'https://go.ackuretta.com/concierge-service/warranty',
						},
						{
							title: 'Concierge World Policy',
							image:
								window.ackShopifyFileUrl("Concierge_World_logo_Color.png"),
							url: 'https://go.ackuretta.com/concierge-world/warranty',
						},
					],
				},
			],
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
